<template>
    <app-layout title="Admin">
        <template #header>
            <page-title title="Admin" />
        </template>

        <template #pageContent>
            <div id="users">
                <h2>Actieve gebruikers</h2>
                <Input type="search" placeholder="Gebruiker zoeken" v-model="searchUser" name="search-user" />
                <Table id="admin-overview-users" :values="filteredUsers" :pageSize="10">
                    <thead>
                    <Th id="name">Naam</Th>
                    <Th id="username">Gebruikersnaam</Th>
                    <Th id="email">Email</Th>
                    <Th id="function">Functie</Th>
                    <Th id="activate_on">In dienst op</Th>
                    <Th id="deactivate_on">Uit dienst op</Th>
                    <Th :sort="false"></Th>
                    </thead>
                    <tbody>
                    <tr v-for="user in state.sortedValues['admin-overview-users']" :key="user.id">
                        <Td>{{ user.name }}</Td>
                        <Td>{{ user.username }}</Td>
                        <Td>{{ user.email }}</Td>
                        <Td>{{ user.function }}</Td>
                        <Td>{{ user.activate_on }}</Td>
                        <Td>{{ user.deactivate_on }}</Td>
                        <Td>
                            <Button
                                htmlType="a"
                                buttonClass="show"
                                size="small"
                                title="Gebruiker bekijken"
                                :href="route('admin.users.show', {'id':user.id})"
                            />
                            <Button
                                htmlType="a"
                                buttonClass="edit"
                                size="small"
                                title="Gebruiker aanpassen"
                                :href="route('admin.users.edit', {'id':user.id})"
                            />
                        </Td>
                    </tr>
                    </tbody>
                </Table>
            </div>
            <div class="mt-4 grid grid-cols-2 gap-2">
                <div id="roles">
                    <h2>Actieve rollen</h2>
                    <Input type="search" placeholder="Rol zoeken" v-model="searchRole" name="search-role" />
                    <Table id="admin-overview-roles" :values="filteredRoles" :pageSize="10">
                        <tbody>
                        <tr v-for="role in state.sortedValues['admin-overview-roles']" :key="role.id">
                            <Td>
                                <div>
                                    <div class="float-left mr-4">
                                        <Modal
                                            :id="role.id"
                                            buttonClass="info"
                                            buttonSize="small"
                                        >
                                            <div>
                                                <h3>Rol '{{ role.name }}'</h3>
                                                <h4>Rechten</h4>
                                                <ul>
                                                    <li v-for="permission in role.permissions">{{ permission.name }}</li>
                                                </ul>
                                                <h4>Afdelingen</h4>
                                                <ul>
                                                    <li v-for="department in role.departments">{{ department.department }}</li>
                                                </ul>
                                            </div>
                                        </Modal>
                                    </div>
                                    <p class="float-left">{{role.name}}</p>
                                    <p class="float-right">Niveau {{ role.level }}</p>
                                </div>
                            </Td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
                <div id="permissions">
                    <h2>Actieve rechten</h2>
                    <Input type="search" placeholder="Recht zoeken" v-model="searchPermission" name="search-permission" />
                    <Table id="admin-overview-permissions" :values="filteredPermissions" :pageSize="10">
                        <tbody>
                        <tr v-for="permission in state.sortedValues['admin-overview-permissions']" :key="permission.id">
                            <Td>
                                <div class="float-left mr-4">
                                    <Modal
                                        :id="permission.id"
                                        buttonClass="info"
                                        buttonSize="small"
                                    >
                                        <div>
                                            <h3>Rollen voor het recht '{{ permission.name }}'</h3>
                                            <ul>
                                                <li v-for="role in permission.roles">
                                                    <p>{{role.name}} (Niveau {{ role.level }})</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </Modal>
                                </div>
                                <p class="float-left">{{ permission.name }}</p>
                            </Td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'

import { Link } from '@inertiajs/inertia-vue3';
import store from '@/store'

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input
    },
    props:[
        'users',
        'roles_list',
        'permissions'
    ],
    data() {
        return {
            searchRole: '',
            searchPermission: '',
            searchUser: '',
        };
    },
    setup (props){

        return {
            state: store.state,
            ...store,
        }
    },
    computed: {
        filteredRoles(){
            return this.roles_list.filter(role => {
                return role.name.toLowerCase().includes(this.searchRole.toLowerCase())
            })
        },
        filteredPermissions(){
            return this.permissions.filter(permission => {
                return permission.name.toLowerCase().includes(this.searchPermission.toLowerCase())
            })
        },
        filteredUsers(){
            return this.users.filter(user => {
                return user.name.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.username.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.email.toLowerCase().includes(this.searchUser.toLowerCase()) ||
                    user.function.toLowerCase().includes(this.searchUser.toLowerCase())
            })
        },
    },
}

</script>
